import type React from "react";
import { Box, Typography } from "@mui/material";
import MemoryBookAssignment from "../../view-stream/MemoryBookAssignment";
import type { IStreamDetails } from "../../../../types/streams";

interface MemoryBookTabProps {
  stream: IStreamDetails;
}

const MemoryBookTab: React.FC<MemoryBookTabProps> = ({ stream }) => {
  const isFuneral =
    stream.booking?.service?.toLowerCase() === "funeral" ||
    stream.booking?.service?.toLowerCase() === "funeralhome";

  const deceased = stream.booking?.deceased?.[0];
  const deceasedName = deceased
    ? `${deceased.first_name} ${deceased.surname}`.trim()
    : stream.title;

  if (!isFuneral) {
    return (
      <Box sx={{ p: 3, textAlign: "center" }}>
        <Typography color="text.secondary">
          Memory book is only available for funeral streams.
        </Typography>
      </Box>
    );
  }

  return (
    <MemoryBookAssignment streamId={stream.id} deceasedName={deceasedName} />
  );
};

export default MemoryBookTab;
